import $ from 'jquery'

Ready(function() {
  const requirementRuleKeySelector = "form[id*='requirement_rule'] select[name='requirement_rule[key]']"

  $(requirementRuleKeySelector).change(function(e) {
    let key = $(this).children('option:selected').val()

    let optionsContainerSelector = `.requirement-rule-options-container[data-for = '${key}']`
    let otherOptionContainersSelector = `.requirement-rule-options-container:not([data-for = '${key}'])`

    $(otherOptionContainersSelector).hide()
    $(`${otherOptionContainersSelector} select`).prop('disabled', true)

    $(optionsContainerSelector).show()
    $(`${optionsContainerSelector} select`).prop('disabled', false)
  })

})
